import { config } from "@fortawesome/fontawesome-svg-core";
import "@fortawesome/fontawesome-svg-core/styles.css";
import React, { ReactNode } from "react";
import { getMedia } from "./Img";
import { Locale, LocaleLanguage } from "./Languages";
import { TrackPageVisit } from "./tracking/trackUser";
config.autoAddCss = false;

export const PageMeta = (props: {
    title: string;
    description: string;
    author?: string;
    locale: Locale;
    canonicalLink?: string;
    path?: string;
    imageUrl?: string;
    noTrack?: boolean;
    children?: ReactNode;
}) => {
    return (
        <>
            <html lang={props.locale === "PT-BR" ? "pt" : LocaleLanguage[props.locale].toLowerCase()} />
            <title>{props.title}</title>
            {process.env.GATSBY_BRANCH === "staging" && (
                <meta name="google-site-verification" content="fY9YpJzqvw5ORG6pthRZREPxiDeJJKo6s__WDoScbi4" />
            )}
            <meta httpEquiv="content-language" content={props.locale.toLowerCase()} />
            <meta property="title" content={props.title} key="title" />
            <meta name="description" content={props.description} />
            <meta name="author" content={props.author} />

            {/* 
                Following pages qualify for full hrefLang, as they exist in every language subroute:
                    "/"
                    "book-a-meeting/"
                    "industry/solar/"
                    "about/us/"
                    "about/team/"
                    "about/jobs/"
                    "legal/cookies/"
                    "legal/imprint/"
                    "legal/dataprotection/"
            */}
            {props.path && (
                <>
                    {/* en / gb / us */}
                    <link rel="alternate" hrefLang="en" href={`${process.env.GATSBY_BASE_URL}/en-gb${props.path}`} />
                    <link rel="alternate" hrefLang="en-gb" href={`${process.env.GATSBY_BASE_URL}/en-gb${props.path}`} />
                    <link rel="alternate" hrefLang="en-us" href={`${process.env.GATSBY_BASE_URL}/en-gb${props.path}`} />
                    <link rel="alternate" hrefLang="en-ca" href={`${process.env.GATSBY_BASE_URL}/en-gb${props.path}`} />
                    {/* it */}
                    <link rel="alternate" hrefLang="it-it" href={`${process.env.GATSBY_BASE_URL}/it-it${props.path}`} />
                    <link rel="alternate" hrefLang="it" href={`${process.env.GATSBY_BASE_URL}/it-it${props.path}`} />
                    {/* pl */}
                    <link rel="alternate" hrefLang="pl-pl" href={`${process.env.GATSBY_BASE_URL}/pl-pl${props.path}`} />
                    <link rel="alternate" hrefLang="pl" href={`${process.env.GATSBY_BASE_URL}/pl-pl${props.path}`} />
                    {/* fr */}
                    <link rel="alternate" hrefLang="fr-fr" href={`${process.env.GATSBY_BASE_URL}/fr-fr${props.path}`} />
                    <link rel="alternate" hrefLang="fr-ca" href={`${process.env.GATSBY_BASE_URL}/fr-fr${props.path}`} />
                    <link rel="alternate" hrefLang="fr" href={`${process.env.GATSBY_BASE_URL}/fr-fr${props.path}`} />
                    {/* es */}
                    <link rel="alternate" hrefLang="es-es" href={`${process.env.GATSBY_BASE_URL}/es-es${props.path}`} />
                    <link rel="alternate" hrefLang="es" href={`${process.env.GATSBY_BASE_URL}/es-es${props.path}`} />
                    {/* pt */}
                    <link rel="alternate" hrefLang="pt-pt" href={`${process.env.GATSBY_BASE_URL}/pt-pt${props.path}`} />
                    <link rel="alternate" hrefLang="pt" href={`${process.env.GATSBY_BASE_URL}/pt-pt${props.path}`} />
                    {/* pt-br */}
                    <link rel="alternate" hrefLang="pt-br" href={`${process.env.GATSBY_BASE_URL}/pt-br${props.path}`} />
                    {/* it */}
                    <link rel="alternate" hrefLang="it-it" href={`${process.env.GATSBY_BASE_URL}/it-it${props.path}`} />
                    <link rel="alternate" hrefLang="it" href={`${process.env.GATSBY_BASE_URL}/it-it${props.path}`} />
                    {/* sv */}
                    <link rel="alternate" hrefLang="sv-se" href={`${process.env.GATSBY_BASE_URL}/sv-se${props.path}`} />
                    <link rel="alternate" hrefLang="sv" href={`${process.env.GATSBY_BASE_URL}/sv-se${props.path}`} />
                    {/* de-de */}
                    <link rel="alternate" hrefLang="de-de" href={`${process.env.GATSBY_BASE_URL}/de-de${props.path}`} />
                    {/* de-at */}
                    <link rel="alternate" hrefLang="de-at" href={`${process.env.GATSBY_BASE_URL}/de-de${props.path}`} />
                    {/* de-ch */}
                    <link rel="alternate" hrefLang="de-ch" href={`${process.env.GATSBY_BASE_URL}/de-de${props.path}`} />
                    {/* de */}
                    <link rel="alternate" hrefLang="de" href={`${process.env.GATSBY_BASE_URL}/de-de${props.path}`} />

                    {/* default */}
                    <link
                        rel="alternate"
                        hrefLang="x-default"
                        href={`${process.env.GATSBY_BASE_URL}/de-de${props.path}`}
                    />
                </>
            )}

            {/* <!-- Facebook Meta Tags --> */}
            {/* <meta property="og:url" content="https://reonic.com/de-de" /> */}
            <meta property="og:type" content="website" />
            <meta property="og:title" content={props.title} />
            <meta property="og:description" content={props.description} />
            <meta property="og:image" content={props.imageUrl ?? getMedia("/images/logo_for_preview.png", "lg")} />

            {/* <!-- Twitter Meta Tags --> */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={props.title} />
            <meta name="twitter:description" content={props.description} />
            <meta name="twitter:image" content={props.imageUrl ?? getMedia("/images/logo_for_preview.png", "lg")} />

            {props.canonicalLink && <link rel="canonical" href={props.canonicalLink} />}
            {!props.noTrack && <TrackPageVisit locale={props.locale} />}
            {props.children}
        </>
    );
};
